"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const PreviewPanel_1 = __importDefault(require("./ExampleChatInput/PreviewPanel"));
const react_dnd_1 = require("react-dnd");
const react_2 = require("react");
const react_dnd_2 = require("react-dnd");
const SessionContext_1 = require("../context/SessionContext");
const api_1 = require("../api");
const FormSettingsContext_1 = require("../context/FormSettingsContext");
const MainCanvas = () => {
    const { session } = (0, SessionContext_1.useSession)();
    const { addFieldToSchema, generatedCode } = (0, FormSettingsContext_1.useFormSetting)();
    const canvasRef = (0, react_2.useRef)(null);
    const dragDropManager = (0, react_dnd_2.useDragDropManager)();
    const monitor = dragDropManager.getMonitor();
    const [isDragging, setIsDragging] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        const unsubscribe = monitor.subscribeToStateChange(() => {
            setIsDragging(monitor.isDragging());
        });
        return () => unsubscribe();
    }, [monitor]);
    const [{ isOver }, drop] = (0, react_dnd_1.useDrop)({
        accept: "form-element",
        drop: (item) => {
            console.log("📥 Dropped item (question):", item);
            addFieldToSchema(item);
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    });
    (0, react_2.useEffect)(() => {
        if (canvasRef.current) {
            drop(canvasRef);
        }
    }, [canvasRef]);
    return ((0, jsx_runtime_1.jsxs)("div", { ref: canvasRef, style: { position: "relative", flex: 1, display: "flex", flexDirection: "column", background: "#f4f4f4" }, children: [isOver && ((0, jsx_runtime_1.jsx)("div", { style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    // width: "100%",
                    height: "100%",
                    background: "rgba(115, 86, 250, 0.15)",
                    border: "2px dashed #7356fa",
                    zIndex: 10,
                    pointerEvents: "none",
                    transition: "background 0.2s, border 0.2s"
                } })), (0, jsx_runtime_1.jsx)(PreviewPanel_1.default, { generatedCode: generatedCode, handleRefresh: () => { }, isDragging: isDragging, docType: (session === null || session === void 0 ? void 0 : session.docType) || api_1.DOC_TYPE.FORM })] }));
};
exports.default = MainCanvas;
